let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6UOB0")).then(() => parcelRequire('20QeA'));